/**
 * @file pages/AboutUs.jsx
 * @description About Us page displaying company information, mission,
 * team details, and background sections with Header and Footer layout.
 */

import React from 'react'
import Header from '../Components/Layouts/Header';
import NikabaFooter from '../Components/Layouts/Footer';
import AboutDetails from '../Components/Sections/AboutDetails';

const About = () => {
  return (
    <div>
      <Header />
      <AboutDetails />
      <NikabaFooter />
    </div>
  )
}

export default About;
